export enum AuthStatus {
    Captcha = 'captcha',
    '2fa' = '2fa',
    '2fa-submit' = '2fa-submit',
    Complete = 'complete',
}
